import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useClienteContext } from '../../../../contexts/ClienteContext';
import { useEmpresaContext } from '../../../../contexts/EmpresaContext';
import axiosAuth from '../../../../services/axiosAuth';
import { generarPdfStockVentaAnticipada } from '../../../../services/generarPdfStockVentaAnticipada';
import DetalleStockVentaAnticipada from '../../DetalleStockVentaAnticipada/DetalleStockVentaAnticipada';
import imagenfondo from '../../../../images/logo-sur.jpg';
import imagenFondoIntegral from '../../../../images/logo-nuevo-srl.jpg';
import { ChevronUp, ChevronDown, Printer, BookOpen, AlertCircle, Loader2 } from 'lucide-react';



const COLUMNAS = [
    { label: 'Código', title: '' },
    { label: 'Descripción', title: '' },
    { label: 'Entrada', title: '' },
    { label: 'Salida', title: '' },
    { label: 'Saldo', title: '' },
    { label: '', title: 'Detalle' },
];

export default function TablaStockVentaAnticipada() {
    const sucursal = localStorage.getItem('sucursal');
    const fondo = sucursal === 'sur' ? imagenfondo : imagenFondoIntegral;

    const location = useLocation();
    const opcion = new URLSearchParams(location.search).get('opcion');

    const { getCliente } = useClienteContext();
    const data = getCliente();
    const codigo = data.codigoCliente;
    const codDeposito = data.codDeposito;
    const { getEmpresa } = useEmpresaContext();
    const empresa = getEmpresa();

    const [movStock, setMovStock] = useState([]);
    const [mensajeError, setMensajeError] = useState('');
    const [loading, setLoading] = useState(false);
    const [showScrollButtons, setShowScrollButtons] = useState(false);
    const [filterSaldo, setFilterSaldo] = useState(true);

    const [detalleMovStock, setDetalleMovStock] = useState([]);
    const [showDetalle, setShowDetalle] = useState(false);
    const [selectedMov, setSelectedMov] = useState('');

    const tableContainerRef = useRef(null);

    const filteredData = filterSaldo
        ? movStock?.filter(item => item?.Saldo?.toFixed(2) != 0)
        : movStock;

    useEffect(() => {
        setMovStock([]);
        fetchData();
    }, [codigo, opcion]);

    useEffect(() => {
        if (tableContainerRef.current) {
            const { scrollHeight, clientHeight } = tableContainerRef.current;
            setShowScrollButtons(scrollHeight > clientHeight);
            tableContainerRef.current.scrollTop = scrollHeight;
        }
    }, [movStock, filteredData]);

    const fetchData = async () => {
        if (!codigo || !sucursal) { setMensajeError('Código de cliente o sucursal no definido'); return; }
        setLoading(true);
        setMensajeError('');
        try {
            const response = await axiosAuth.get(`/movstock/${sucursal}/stockventaanticipada/${codDeposito}?opcion=${opcion}`);
            setMovStock(response?.data);
        } catch (error) {
            setMensajeError(error.response?.data?.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex flex-col h-full bg-white">

            {/* HEADER */}
            <div className="flex-shrink-0 bg-[#050f08] border-b border-gray-700">
                <div className="px-4 py-1 flex flex-col items-center gap-1">
                    <p className="text-white font-bold text-xs tracking-widest uppercase text-center">
                        Stock {opcion === 'ventaAnticipada' ? 'Venta Anticipada' : 'Total'} — Depósito {codDeposito}
                    </p>
                    <p className="text-gray-400 text-[10px] uppercase tracking-wider">
                        Actualizado: {new Date(empresa?.updatedAt)?.toLocaleString('es-ES', { hour12: false })}
                    </p>
                </div>
            </div>

            {/* TOOLBAR */}
            <div className="flex-shrink-0 bg-white border-b border-gray-200 px-4 py-2 flex items-center justify-between">
                <label className="flex items-center gap-2 cursor-pointer group">
                    <input
                        type="checkbox"
                        checked={filterSaldo}
                        onChange={() => setFilterSaldo(!filterSaldo)}
                        className="w-3.5 h-3.5 rounded border-gray-300 cursor-pointer accent-gray-800"
                    />
                    <span className="text-[10px] font-black uppercase tracking-widest text-gray-500 group-hover:text-gray-800 transition-colors">
                        Con Stock
                    </span>
                </label>
                <button
                    onClick={() => generarPdfStockVentaAnticipada(filteredData, data, empresa)}
                    disabled={!filteredData?.length}
                    className="flex items-center gap-2 bg-gray-900 hover:bg-gray-700 disabled:opacity-30 disabled:cursor-not-allowed text-white text-[10px] font-black uppercase tracking-widest px-5 py-2 rounded-xl transition-all">
                    <Printer size={14} />
                    Imprimir
                </button>
            </div>

            {/* TABLA */}
            <div className="overflow-auto relative flex-1" ref={tableContainerRef}
                style={{
                    backgroundImage: `url(${fondo})`,
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                }}>

                {loading && (
                    <div className="absolute inset-0 bg-white/80 flex items-center justify-center z-10">
                        <div className="flex flex-col items-center gap-3">
                            <Loader2 size={28} className="text-gray-400 animate-spin" />
                            <span className="text-gray-400 text-xs uppercase tracking-widest font-bold">Cargando...</span>
                        </div>
                    </div>
                )}

                {!loading && mensajeError && (
                    <div className="m-4 flex items-center gap-3 bg-red-50 border border-red-200 rounded-xl px-4 py-3">
                        <AlertCircle size={16} className="text-red-400 flex-shrink-0" />
                        <p className="text-red-600 text-xs font-black uppercase tracking-wider">{mensajeError}</p>
                    </div>
                )}

                {!loading && !mensajeError && filteredData?.length === 0 && (
                    <div className="m-4 flex items-center gap-3 bg-gray-50 border border-gray-200 rounded-xl px-4 py-3">
                        <AlertCircle size={16} className="text-gray-400 flex-shrink-0" />
                        <p className="text-gray-500 text-xs font-black uppercase tracking-wider">Sin stock disponible</p>
                    </div>
                )}

                <table className="w-full border-collapse text-xs">
                    <thead>
                        <tr className="bg-gray-800 sticky top-0 z-10">
                            {COLUMNAS.map((col, i) => (
                                <th key={i} title={col.title}
                                    className="sticky top-0 px-2 py-1 border-r border-gray-700 text-white/80 font-bold uppercase tracking-wider whitespace-nowrap text-center last:border-r-0">
                                    {col.label}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {filteredData?.map((mov, index) => (
                            <tr key={index} className="bg-white/85 hover:bg-blue-200 transition-colors border-b border-gray-200 text-center">
                                <td className="px-2 py-1 border-r border-gray-100 text-gray-600 font-mono">{mov?.Codarticulo}</td>
                                <td className="px-2 py-1 border-r border-gray-100 text-left text-gray-700">{mov?.Descarticulo}</td>
                                <td className="px-2 py-1 border-r border-gray-100 text-right text-gray-700 font-mono">{mov?.Entrada?.toFixed(3)}</td>
                                <td className="px-2 py-1 border-r border-gray-100 text-right text-red-600 font-mono font-semibold">{mov?.Salida?.toFixed(3)}</td>
                                <td className="px-2 py-1 border-r border-gray-100 text-right text-gray-900 font-mono font-black">{mov?.Saldo?.toFixed(3)}</td>
                                <td className="px-2 py-1">
                                    <button onClick={() => { setSelectedMov(mov); setDetalleMovStock(mov?.Detalle); setShowDetalle(true); }}
                                        className="flex items-center justify-center mx-auto text-gray-400 hover:text-blue-600 transition-colors">
                                        <BookOpen size={15} />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* FOOTER */}
            <div className="flex-shrink-0 bg-[#050f08] px-4 py-4 md:py-0.5 lg:py-0.5 flex items-center justify-between">
                <span className="text-gray-400 text-[12px] md:text-[10px] lg:text-[10px] uppercase tracking-widest font-bold">Stock</span>
                <span className="text-white font-black text-sm">
                    {filteredData?.length || 0} REGISTROS
                </span>
                {showScrollButtons && (
                    <div className="flex gap-2">
                        <button onClick={() => tableContainerRef.current.scrollTop = 0}
                            className="w-12 h-12  md:w-7 md:h-7 lg:w-7 lg:h-7 bg-gray-700 hover:bg-gray-600 rounded-full flex items-center justify-center text-white transition-all">
                            <ChevronUp size={14} />
                        </button>
                        <button onClick={() => tableContainerRef.current.scrollTop = tableContainerRef.current.scrollHeight}
                            className="w-12 h-12  md:w-7 md:h-7 lg:w-7 lg:h-7 bg-gray-700 hover:bg-gray-600 rounded-full flex items-center justify-center text-white transition-all">
                            <ChevronDown size={14} />
                        </button>
                    </div>
                )}
            </div>

            {/* MODAL DETALLE */}
            {showDetalle && (
                <DetalleStockVentaAnticipada
                    detalleMovStock={detalleMovStock}
                    onClose={() => { setShowDetalle(false); setDetalleMovStock(''); }}
                    movStockVtaAnticipada={selectedMov}
                />
            )}
        </div>
    );
}
